export default __webpack_public_path__ + "static/right-timesquare-a7ef0727cc49dbf7d555c4a78de48054.png";